import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import BarChartIcon from '@material-ui/icons/BarChart';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 260,
        height: '100%',
        width: '100%',
        padding: theme.spacing(3),
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        boxSizing: 'border-box'
    },
    icon: {
        fontSize: 48,
        color: '#D1D5DB', // gray-300
        marginBottom: theme.spacing(1)
    },
    message: {
        color: '#6B7280', // gray-500
        fontSize: '14px',
        fontWeight: 500,
        textAlign: 'center'
    }
}));

export function AtNoData({ message, icon: CustomIcon, minHeight }) {
    const classes = useStyles();
    const { t } = useTranslation();
    const IconComponent = CustomIcon || BarChartIcon;

    return (
        <Box className={classes.container} style={minHeight ? { minHeight } : {}}>
            <IconComponent className={classes.icon} />
            <Typography className={classes.message}>
                {message || t('text.no-data')}
            </Typography>
        </Box>
    );
}
